module.exports = __webpack_public_path__ + "static/img/merchant_feature_12.2fb339a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_12.png
// module id = 5eiB
// module chunks = 8